import { render, staticRenderFns } from "./v-pagination.vue?vue&type=template&id=c9ab16c6&scoped=true&"
import script from "./v-pagination.vue?vue&type=script&lang=js&"
export * from "./v-pagination.vue?vue&type=script&lang=js&"
import style0 from "./v-pagination.vue?vue&type=style&index=0&id=c9ab16c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ab16c6",
  null
  
)

export default component.exports